export default __webpack_public_path__ + "static/media/coursegift.749567d6.gif";